import { motion } from "framer-motion";

/**
 * Wrapper leggero per rivelare i contenuti allo scroll.
 * Anima UNA sola volta (viewport once) usando solo opacity/transform.
 *
 * @param {object} props
 * @param {number} [props.delay=0] ritardo in secondi
 * @param {number} [props.y=24] spostamento verticale iniziale (px)
 * @param {string} [props.as] tag/motion element (default div)
 */
export default function Reveal({
  children,
  className,
  delay = 0,
  y = 24,
  once = true,
  ...rest
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.25 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
